import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import {
  FormField,
  FormItem,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { BIG_ITEMS } from "@/constants";

const Items: React.FC = () => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name="big_items"
      render={() => (
        <FormItem className="mt-2">
          {/* <Label>Big Items</Label> */}
          <FormControl>
            <Controller
              name="big_items"
              control={control}
              render={({ field }) => (
                <ToggleGroup
                  type="multiple"
                  value={field.value}
                  onValueChange={(value) => field.onChange(value)}
                  className="grid grid-cols-3 gap-2"
                >
                  {BIG_ITEMS.map((item) => (
                    <ToggleGroupItem
                      key={item}
                      value={item}
                      className="px-2 py-1 rounded-md col-span-1 hover:border hover:border-yellow-300 hover:bg-white hover:text-black data-[state=on]:bg-yellow-400"
                    >
                      {item}
                    </ToggleGroupItem>
                  ))}
                </ToggleGroup>
              )}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default Items;
